import React, { useEffect, useState } from "react";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import BackIcon from "../../../comman/action/BackIcon";
import { catchMessage, elseMessage } from "../../../comman/Message";
import { useParams } from "react-router-dom";
import { postDetailsApi } from "../../../services/community";
import { Avatar } from "@mui/material";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import { dateTime, formatContent } from "../../../components/Form";

const ShareDetails = () => {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { id } = useParams();
  const [postDetail, setPostDetail] = useState("");
  const [media, setMedia] = useState([]);
  // console.log('postDetail', postDetail)

  // Helper function to determine if a file is a video
  const isVideo = (filename) => {
    const videoExtensions = ["mp4", "webm", "ogg"];
    const extension = filename.split(".").pop();
    return videoExtensions.includes(extension);
  };
  // Function to replace custom markdown and URLs
  // const formatContent = (content) => {
  //     // Replace custom markdown patterns
  //     let formattedContent = content.replace(/#\[(\w+)\]\(undefined\)/g, '#$1');

  //     // Replace URLs with anchor tags
  //     const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g;
  //     formattedContent = formattedContent.replace(urlRegex, (url) => {
  //         let hyperlink = url;
  //         if (!hyperlink.startsWith('http')) {
  //             hyperlink = 'http://' + hyperlink;
  //         }
  //         return `<a href="${hyperlink}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  //     });

  //     return formattedContent;
  // };

  const postDetails = async () => {
    try {
      showLoader();
      const res = await postDetailsApi({ postId: id });
      if (res?.data?.status === 200) {
        const data = res?.data?.data;
        setPostDetail(data);
        setMedia(data?.media);
      } else {
        elseMessage(res);
      }
    } catch (err) {
      catchMessage(err);
    } finally {
      hideLoader();
    }
  };
  useEffect(() => {
    postDetails();
  }, [id]);
  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">
              <BackIcon />
              Post Details
            </h4>
          </div>
          <div className="customer_details">
            <div className="innner">
              <ul>
                <li>
                  <strong>Name </strong>
                  <span>: {postDetail?.author?.name || "N/A"}</span>
                </li>
                <li>
                  <strong>USer Name </strong>
                  <span>: {postDetail?.author?.userName || "N/A"}</span>
                </li>
                <li>
                  <strong>Date & Time </strong>
                  <span>: {dateTime(postDetail?.createdAt) || "N/A"}</span>
                </li>
                <li>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: formatContent(postDetail?.content || ""),
                    }}
                  />
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            {media.length > 0 ? (
              media.map((data, index) => {
                const isMediaVideo = isVideo(data?.name);

                return (
                  <div key={index} className="col-4 mb-2">
                    {isMediaVideo ? (
                      <video
                        className="w-100"
                        controls
                        style={{
                          width: 370,
                          height: 170,
                          borderRadius: 2,
                          borderColor: "#9dc4b4",
                        }}
                      >
                        <source
                          src={data?.name}
                          type={`video/${data?.name.split(".").pop()}`}
                        />
                        Your browser does not support the video tag.
                      </video>
                    ) : (
                      <Avatar
                        className="w-100"
                        variant="rounded"
                        src={data?.name}
                        sx={{
                          width: 370,
                          height: 170,
                          borderRadius: 2,
                          borderColor: "#9dc4b4",
                        }}
                      >
                        <InsertPhotoIcon sx={{ fontSize: 100 }} />
                      </Avatar>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="col-4 mb-2">
                <Avatar
                  className="w-100"
                  variant="rounded"
                  sx={{
                    width: 370,
                    height: 170,
                    borderRadius: 2,
                    borderColor: "#9dc4b4",
                  }}
                >
                  <InsertPhotoIcon sx={{ fontSize: 100 }} />
                </Avatar>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareDetails;
